'use strict';

const { hydrate } = require('@grpn/hydration');

const RedemptionProvider = require('./redemption-provider');

module.exports = hydrate('RedemptionProvider', RedemptionProvider);
